module.exports = __webpack_public_path__ + "static/img/gsds.31a142a.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/example/gsds.png
// module id = YQmV
// module chunks = 1